import { AfterViewInit, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Logger } from 'src/app/core/logger';
import { FieldOptionModel } from 'src/app/models/widgets/field-option.model';
import { WidgetsInputModel } from 'src/app/models/widgets/widgets-input.model';
import { merge } from 'lodash';
import { MetadataTemplateService } from 'src/app/services/metadata/metadata-template.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'appMetadataInput',
  templateUrl: './metadata-input.component.html',
  styleUrls: ['./metadata-input.component.scss'],
})
export class MetadataInputComponent implements OnInit {
  @Input() data: WidgetsInputModel = new WidgetsInputModel();
  template?: string;
  // https://stackblitz.com/edit/form-array-angular-yvow9n?file=src%2Fapp%2Fapp.component.ts
  // https://stackblitz.com/edit/angular-forms-formarray-example-leedar?file=src%2Fapp%2Fapp.component.html
  form: FormGroup;
  nextValue: number = 0;
  errorMessage: string = '';
  isVisible = true;
  isDisable = false;
  // minNum?: number;
  target: any;

  constructor(
    private fb: FormBuilder,
    public cd: ChangeDetectorRef,
    private logger: Logger,
    private templateService: MetadataTemplateService
  ) {
    this.form = this.fb.group({
      heading: [this.data.label, Validators.maxLength(30)],
      description: ['', Validators.maxLength(100)],
      reqCheck: [this.data.required],
      suffix: [this.data.suffix],
      suffixText: [this.data.suffixText, Validators.maxLength(30)],
      prefix: [this.data.prefix],
      prefixText: [this.data.prefixText, Validators.maxLength(30)],
      minTextLength: [this.data.minTextLength],
      maxTextLength: [this.data.maxTextLength],
      pattern: [this.data.pattern, Validators.pattern(/[A-Za-z]{3}/)],
      minNum: [this.data.minNum],
      maxNum: [this.data.maxNum],
      isMaxCurrentYear: [this.data.isMaxCurrentYear,],
      isMinCurrentYear: [this.data.isMinCurrentYear],
      isDecimal: [this.data.isDecimal],
      isPasteEnabled: [this.data.isPasteEnabled],
      isNumeric: [this.data.isNumeric],
      validateOnBlur: [this.data.validateOnBlur],
      commentKey: ['', Validators.maxLength(30)],   
      commentFieldOnOptional: [false, [Validators.required]]   
    });

    this.setProperties();

  }
  setProperties() {
    this.form.get('heading')?.valueChanges.subscribe(label => {
      this.data.label = this.form.controls.heading.value;
    });
    this.form.get('reqCheck')?.valueChanges.subscribe(reqCheck => {
      this.data.required = this.form.controls.reqCheck.value;
    });
    this.form.get('suffix')?.valueChanges.subscribe(suffix => {
      this.data.suffix = this.form.controls.suffix.value;
    });
    this.form.get('suffixText')?.valueChanges.subscribe(suffixText => {
      this.data.suffixText = this.form.controls.suffixText.value;
    });
    this.form.get('prefix')?.valueChanges.subscribe(prefix => {
      this.data.prefix = this.form.controls.prefix.value;
    });
    this.form.get('prefixText')?.valueChanges.subscribe(prefixText => {
      this.data.prefixText = this.form.controls.prefixText.value;
    });
    this.form.get('isMaxCurrentYear')?.valueChanges.subscribe(value => {
      this.data.isMaxCurrentYear = this.form.controls.isMaxCurrentYear.value;
      // Check before current year
      if (this.form.controls.isMaxCurrentYear.value) {
        // If true then assign undefined to max number
        this.data.minNum = undefined;
      } else {
        // If true then assign value to max number
        this.data.minNum = this.form.controls.minNum.value;
      }
    });
    this.form.get('isMinCurrentYear')?.valueChanges.subscribe(isMinCurrentYear => {
      this.data.isMinCurrentYear = this.form.controls.isMinCurrentYear.value;
      // Check After current year
      if (this.form.controls.isMinCurrentYear.value) {
        // If true then assign undefined to max number
        this.data.maxNum = undefined;
      } else {
        // If true then assign value to max number
        this.data.maxNum = this.form.controls.maxNum.value;
      }
    });
    this.form.get('maxNum')?.valueChanges.subscribe(maxNum => {
      // Check After current year
      if (this.form.controls.isMinCurrentYear.value) {
        // If true then assign undefined to max number
        this.data.maxNum = undefined;
      } else {
        // If true then assign value to max number
        this.data.maxNum = this.form.controls.maxNum.value;
      }
    });
    this.form.get('minNum')?.valueChanges.subscribe(minNum => {
      // this.data.minNum = this.form.controls.minNum.value;
      // Check before current year
      if (this.form.controls.isMaxCurrentYear.value) {
        // If true then assign undefined to min number
        this.data.minNum = undefined;
      } else {
        // If true then assign value to min number
        this.data.minNum = this.form.controls.minNum.value;
      }
    });
    this.form.get('isDecimal')?.valueChanges.subscribe(isDecimal => {
      this.data.isDecimal = this.form.controls.isDecimal.value;
    });
    this.form.get('isNumeric')?.valueChanges.subscribe(isNumeric => {
      this.data.isNumeric = this.form.controls.isNumeric.value;
    });
    this.form.get('validateOnBlur')?.valueChanges.subscribe(validateOnBlur => {
      this.data.validateOnBlur = this.form.controls.validateOnBlur.value;
    });
    this.form.get('isPasteEnabled')?.valueChanges.subscribe(isPasteEnabled => {
      this.data.isPasteEnabled = this.form.controls.isPasteEnabled.value;
    });
    this.form.get('maxTextLength')?.valueChanges.subscribe(maxTextLength => {
      this.data.maxTextLength = this.form.controls.maxTextLength.value;
    });
    this.form.get('minTextLength')?.valueChanges.subscribe(minTextLength => {
      this.data.minTextLength = this.form.controls.minTextLength.value;
    });
    this.form.get('pattern')?.valueChanges.subscribe(pattern => {
      this.data.pattern = this.form.controls.pattern.value;
    });
    this.form.get('commentFieldOnOptional')?.valueChanges.subscribe(commentFieldOnOptional => {
      this.data.commentFieldOnOptional = this.form.controls.commentFieldOnOptional.value;
    });

  }

  ngOnInit(): void {

    this.setFormValues();
  }

  setFormValues() {
      if (this.data.isNumeric) {
        this.form.controls.isNumeric.setValue(this.data.isNumeric);
      }
      if (this.data.validateOnBlur) {
        this.form.controls.validateOnBlur.setValue(this.data.validateOnBlur);
      }
      if (this.data.required) {
        this.form.controls.reqCheck.setValue(this.data.required);
      }
      if (this.data.suffix) {
        this.form.controls.suffix.setValue(this.data.suffix);
        this.form.controls.suffixText.setValue(this.data.suffixText);
      }
      if (this.data.prefix) {
        this.form.controls.prefix.setValue(this.data.prefix);
        this.form.controls.prefixText.setValue(this.data.prefixText);
      }
      if (this.data.isMaxCurrentYear) {
        this.form.controls.isMaxCurrentYear.setValue(this.data.isMaxCurrentYear);
      }
      if (this.data.isMinCurrentYear) {
        this.form.controls.isMinCurrentYear.setValue(this.data.isMinCurrentYear);
      }
      if (this.data.isPasteEnabled) {
        this.form.controls.isPasteEnabled.setValue(this.data.isPasteEnabled);
      }
      if (this.data.isDecimal) {
        this.form.controls.isDecimal.setValue(this.data.isDecimal);
      }
      if (this.data.isPasteEnabled) {
        this.form.controls.isPasteEnabled.setValue(this.data.isPasteEnabled);
      }
      if (this.data.maxTextLength) {
        this.form.controls.maxTextLength.setValue(this.data.maxTextLength);
      }
      if (this.data.minTextLength) {
        this.form.controls.minTextLength.setValue(this.data.minTextLength);
      }
      if (this.data.minNum !== undefined || this.data.minNum !== null) {
        this.form.controls.minNum.setValue(this.data.minNum);
      }
      if (this.data.maxNum !== undefined || this.data.maxNum !== null) {
        this.form.controls.maxNum.setValue(this.data.maxNum);
      }
      if (this.data.pattern) {
        this.form.controls.pattern.setValue(this.data.pattern);
      }
      if (this.data.commentKey) {
        this.form.controls.commentKey.setValue(this.data.commentKey);
      }
      if(this.data.commentFieldOnOptional){
        this.form.controls.commentFieldOnOptional.setValue(this.data.commentFieldOnOptional);
      }
  }

  onMinenabled() {
    this.form.get('minNum')?.valueChanges.subscribe(minNum => {
      this.data.minNum = this.form.controls.minNum.value;
    });
  }

  getModifiedTemplate(modifiedTemplate){
    this.data = this.templateService.getModifiedTemplate(modifiedTemplate, this.data);
    // Trigger value change
    this.template = this.data.template;
  }

  onChangeCommentKey(value) {
    try {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      this.data.commentKey = this.form.controls['commentKey'].value as string;
    } catch (error) {
      console.log("commentKey "+error);
    }
  }

  onChangeCommentFieldOnOptional(value) {
    try {
      // eslint-disable-next-line @typescript-eslint/dot-notation
      this.data.commentFieldOnOptional = this.form.controls['commentFieldOnOptional'].value as boolean;
    } catch (error) {
      console.log("commentFieldOnOptional "+error);
    }
  }  
}